import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import Query from "@qpr/client-api-base/querybuilder/Query";
import defaultAttributes from "backend/defaultAttributes";
import { ICardElementWithChildren } from "backend/model/model";
import { resultSort } from "init/sort";
import React from "react";
import { useQuery } from "react-query";
import useModel from "../model/useModel";
import usePeriodLevels from "../model/usePeriodLevels";

const useSubobjects = () => {
  const ctx = useAppContext();
  const { data: model, isLoading } = useModel();
  const { data: periodLevels } = usePeriodLevels();

  return useQuery(
    `data-subobjects-${model?.[0]?.id || ""}-${ctx.period}-${ctx.model}`,
    () => {
      return Query(model?.[0]?.id || "")
        .subobjects({ recursive: 1, criteria: { hasreferencescorecard: "0" } })
        .attributes(
          ...defaultAttributes(ctx.period || "latestforseries", periodLevels!!)
        )
        .fetchValues<ICardElementWithChildren>()
        .then((list) => resultSort(list));
    },
    {
      enabled: !!periodLevels && !isLoading,
      cacheTime: 10 * (60 * 1000),
      staleTime: 10 * (60 * 1000),
    }
  );
};

export default useSubobjects;
